<div class="modal-content">
  <!-- Header -->
  <div class="modal-header company-modal-header">
    <span>Apply Changes to the Live Playbook</span>
    <i class="material-icons" data-bs-dismiss="modal" (click)='closeModal()'>close</i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-4 centerText">
        <span class="color-gray">Draft Section</span>
        <div id="draftSections">
          <select [(ngModel)]="selectedSectionsDraftId" multiple (change)="openDraftSelected()">
            @for (eachDraftSection of allSections  | filterBy: {isDraftMode: true, isDeleted: false} | orderBy:'orderBy'; track eachDraftSection) {
              <option
                title="{{ getTitle(eachDraftSection) }}" value="{{eachDraftSection.sectionId}}"
                [ngClass]="{'deleted': eachDraftSection.isDeleted || eachDraftSection.isDeletedByUser}"
                [hidden]="!(eachDraftSection.sectionTitle && eachDraftSection.sectionTitle != '')"
                [disabled]="eachDraftSection.isDeleted || eachDraftSection.isDeletedByUser">
                {{eachDraftSection.sectionTitle}}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="col-md-3" style="padding-top: 38px">
        <button class="btn vPlaybookDefaultButton btn__btn-default w-100 btn__btn-gray" title="Replace all sections with Draft Mode"
        (click)="replaceAll()" [disabled]="checkReplaceButton()">Replace All</button>
        <button class="btn vPlaybookDefaultButton btn__btn-default w-100 top-spacer-10 btn__btn-gray" title="Move a Draft section to the Live Playbook"
          (click)="apply()" [disabled]="!selectedSectionsDraft.length || selectedSectionsLive.length">Apply
          <!-- = 0  > 0-->
          <span class="material-icons font-size-20 float-end mr-10 ">
            arrow_right_alt
          </span>
        </button>
        <button class="btn vPlaybookDefaultButton btn__btn-default w-100 top-spacer-10 btn__btn-gray"
          title="Remove a section from the Live Playbook to Draft Mode" (click)="remove()"
          [disabled]="!selectedSectionsLive.length || selectedSectionsDraft.length">
          <!-- <= 0  > 0-->
          <span class="material-icons font-size-20 float-start ml-10">
            keyboard_backspace
          </span>
          Remove
        </button>
        <button class="btn vPlaybookDefaultButton btn__btn-default w-100 top-spacer-10 btn__btn-gray" title="Delete this section" (click)="delete()"
          [disabled]="!selectedSectionsLive.length  && !selectedSectionsDraft.length" style="padding-right:10px">
          <!-- <= 0  <= 0 -->
          <span class="material-icons font-size-20 float-start ml-10">
            delete
          </span>
          Delete
        </button>
        <button class="btn vPlaybookDefaultButton btn__btn-default w-100 top-spacer-10 btn__btn-gray" title="Reset sections to original position"
        (click)="resetAll()" [disabled]="">Reset All</button>
      </div>
      <div class="col-md-4 centerText">
        <span class="color-gray">Live Playbook</span>
        <div id="liveSections">
          <select [(ngModel)]="selectedSectionsLiveId" multiple (change)="optionLiveSelected()">
            @for (eachLiveSection of allSections  | filterBy: {isDraftMode: false, isDeleted: false} | orderBy:'orderBy'; track eachLiveSection) {
              <option
                title="{{ getTitle(eachLiveSection) }}" value="{{eachLiveSection.sectionId}}"
                [ngClass]="{'deleted': eachLiveSection.isDeleted || eachLiveSection.isDeletedByUser}"
                [hidden]="!(eachLiveSection.sectionTitle && eachLiveSection.sectionTitle != '')"
                [disabled]="eachLiveSection.isDeleted || eachLiveSection.isDeletedByUser">{{eachLiveSection.sectionTitle}}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="col-md-1 " style="padding-top:115px; margin-left: -10px;" id="reorderIcons">
        <i class="material-icons pointer" title="Move section up" (click)="moveUp()">
          arrow_upward
        </i>
        <i class="material-icons top-spacer-10 pointer" title="Move section down" (click)="moveDown()">
          arrow_downward
        </i>
      </div>
      <div class="clearfix"></div>
    </div>
    <hr>
      <div class="row">
        <div class="col-md-12">
          <span style="font-weight: bold;" class="color-gray">Sections to be Deleted</span>
          <div id="deletedSections">
            <ul>
              @for (eachDeletedSections of deletedSections; track eachDeletedSections) {
                <li>
                  {{eachDeletedSections.sectionTitle}}
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn vPlaybookDefaultButton btn__btn-default" (click)="deleteDraft()" [disabled]="checkReplaceButton()">
        <span class="material-icons font-size-20 float-start mar-rig-5">
          delete
        </span>
      Delete This Draft</button>
      <button class="btn vPlaybookDefaultButton btn__btn-default" (click)="closeModal()">Cancel</button>
      <button class="btn btn__btn-default btn__orange" (click)="save()">Save</button>
    </div>
  </div>
